import { create } from 'zustand';
import { RoleConfigStoreInterface } from './types';

const RoleConfigStore = create<RoleConfigStoreInterface>()((set) => {
  return {
    roleConfig: null,
    roleConfigTags: null,
    roleConfigActions: null,
    roleConfigAllowedSites: null,
    loading: true,
    configs: null,
    allowTenantSiteSelection: false,
    setRoleConfig: (config) => {
      set({ roleConfig: config });
    },
    setRoleConfigTags: (tags) => {
      set({ roleConfigTags: tags });
    },
    setRoleConfigActions: (actions) => {
      set({ roleConfigActions: actions });
    },
    setRoleConfigAllowedSites: (actions) => {
      set({ roleConfigAllowedSites: actions, loading: false });
    },
    setConfigs: (configs) => {
      set({ configs });
    },
    setAllowTenantSiteSelection: (allow: boolean) => {
      set({ allowTenantSiteSelection: allow });
    },
  };
});

export default RoleConfigStore;
